import { Button, Checkbox, FormControlLabel } from "@material-ui/core";
import React from "react";
import StreamLogo from "../../../public/img/common/Stream-Data-Centers_Logo_WHITE.svg";
class OpenPdfDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }



  render() {
    const { isAccept } = this.state;
    const { openSignatureDialog, pdfUrl, pdfHeader, height, agreeText, className } = this.props;
    return (
      <>
        <div className={"terms-cond-container"}>
          <>
            <div className={"layout-topBar"}>
              <div className={"img-logo"}>
                <img src={StreamLogo} alt={"logo"} className={"stream-logo"} />
              </div>
              <div className={"app-name-title"}>
                {"DATA CENTER OPERATIONS PORTAL"}
              </div>
            </div>
            <div>
              <div className={"row login-area-glass"}>
                <div className={"col-xs-12 content page-title"}>
                  {pdfHeader}
                </div>
                <div className={"col-xs-12 content center-xs"}>
                  {
                    <iframe
                      src={pdfUrl}
                      width={"100%"}
                      height={height}
                      scrolling={"auto"}
                      className={"pdfPreview"}
                    />
                  }
                </div>
              </div>
              <div
                className={"row col-xs-12 mt-10 middle-xs checkMark-container"}
              >
                <div className={"col-xs-7 content center-xs"}>
                  {
                    <FormControlLabel
                      className={"checkMark" + " " + className}
                      control={
                        <Checkbox
                          checked={isAccept}
                          onChange={e => {
                            this.setState({ isAccept: e.target.checked });
                          }}
                          style={{ color: "red" }}
                        />
                      }
                      label={agreeText}
                    />
                  }
                </div>
                <div className={"col-xs-5 content middle-xs docu-sign"}>
                  {isAccept ? (
                    <Button
                      className={"sign-btn"}
                      onClick={() => {
                        openSignatureDialog();
                      }}
                    >
                      {"Click Here To Add Signature"}
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </>
        </div>
      </>
    );
  }
}

export default OpenPdfDialog;
